import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Location} from '@angular/common';
import { AppService } from '../app.service';
export interface CheckerData {
  employeeId: string;
  firstName: string;
  lastName: string;
  designation: string;
  grade: string;
  dateOfJoining: string;
  plant: string;
  department: string;
  requester: string;
}

@Component({
  selector: 'app-checkerreview',
  templateUrl: './checkerreview.component.html',
  styleUrls: ['./checkerreview.component.scss']
})
export class CheckerreviewComponent implements OnInit {
checkerForm!: FormGroup;
  checkerData: any = {};
   
  constructor(private fb: FormBuilder,public appservice:AppService,private location:Location,private router: Router,private toastr: ToastrService) { }
  onApprove() {
    this.appservice.checkereditdata.command= this.checkerData.command;
    this.appservice.checkereditdata.createdby=this.appservice.username;
    this.appservice.postTable("api/Transaction/UpdateCheckerstatus",this.appservice.checkereditdata).subscribe((res:any)=>{
      if(res=="True"){
this.toastr.success("Approved successfully!");
this.appservice.getcheckerdata();
this.appservice.goback();
      }
    });
     
   // this.router.navigate(['/finalapprover']);
    
  }
  
  public employees:[
    { employeeId: 'E001', firstName: 'John', lastName: 'Doe', designation: 'Software Engineer', grade: 'A1', dateOfJoining: '2022-01-15', plant: 'Plant 1', department: 'IT', requester: 'Alice' },
    { employeeId: 'E002', firstName: 'Jane', lastName: 'Smith', designation: 'Project Manager', grade: 'B2', dateOfJoining: '2021-03-22', plant: 'Plant 2', department: 'Operations', requester: 'Bob' },
    { employeeId: 'E003', firstName: 'Michael', lastName: 'Johnson', designation: 'HR Executive', grade: 'C3', dateOfJoining: '2020-07-30', plant: 'Plant 1', department: 'HR', requester: 'Charlie' }
  ]

  onDecline() {
     this.appservice.checkereditdata.command= this.checkerData.command;
      this.appservice.checkereditdata.createdby=this.appservice.username;
    this.appservice.postTable("api/Transaction/UpdateCheckerstatus",this.appservice.checkereditdata).subscribe((res:any)=>{
      if(res=="True"){
this.toastr.success("Rejected successfully!");
this.appservice.getcheckerdata();
this.appservice.goback();
      }
    });
  }
  
  back(){
    this.location.back();
  }
employeeid:any=[];
getemployeeid(){
  this.appservice.getTable("Api/Transaction/GetEmployeeid").subscribe((res:any)=>{
    this.employeeid=JSON.parse(res);
    console.log("the values",this.checkerData.employeeid);
  })
}
public employeedetails:any={}
Onselectempolyee(){
  this.appservice.getTable("Api/Transaction/Getempdetails?empid="+this.appservice.Editcheckerdata).subscribe((res:any)=>{
 this.employeedetails=JSON.parse(res);
 console.log("the values",this.employeedetails[0].OD_EmployeeID);
// this.checkerData.employ
 if (this.employeedetails && this.employeedetails.length > 0) {
        let emp = this.employeedetails[0]; // first object
        this.checkerData.OD_EmployeeID  = emp.OD_EmployeeID;
        this.checkerData.firstName    = emp.OD_First_name;
        this.checkerData.lastName     = emp.OD_Last_Name;
        this.checkerData.designation  = emp.OD_Designation;
        this.checkerData.grade        = emp.OD_Grad;
        this.checkerData.dateOfJoining = emp.OD_Dateofjoin;
        console.log(this.formatDDMMYYYYToYYYYMMDD(emp.OD_Dateofjoin)) // may need date formatting
        this.checkerData.plant        = emp.OD_Plant;
        this.checkerData.department   = emp.OD_Department;
        this.checkerData.requester    = emp.OD_OnboardingCreatedby;
        this.checkerData.OD_Account_type = emp.OD_Account_type;
        this.checkerData.Furtherdepartment = emp.OD_Changing_Department
      }
  });
}
formatToDDMMYYYY(dateStr: string): string {
  const date = new Date(dateStr);
  const year = date.getFullYear();
  const month = ("0" + (date.getMonth() + 1)).slice(-2);
  const day = ("0" + date.getDate()).slice(-2);
  return `${day}-${month}-${year}`;
}
formatDDMMYYYYToYYYYMMDD(dateStr: string): string {
  if (!dateStr) return '';

  const [day, month, year] = dateStr.split('-');
  return `${year}-${month}-${day}`;
}
  ngOnInit(): void {
  //  this.getemployeeid();
  this.Onselectempolyee();
  }

  }


